import { LockOutlined, TeamOutlined } from "@ant-design/icons";
import { Radio, Select } from "antd";
import classnames from "classnames";
export const GridItem = ({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) => <div className={classnames("grid grid-cols-3 items-center", className)} data-sentry-component="GridItem" data-sentry-source-file="AnalysisCollectionFormItems.tsx">{children}</div>;
interface AnalysisCollectionPermsItemProps {
  isPrivate: boolean;
  setIsPrivate: (val: boolean) => void;
  enableShare: boolean;
  groupOpts: {
    key: string;
    value: string;
    label: string;
  }[] | undefined;
  groupId: string;
  setGroupId: (val: string) => void;
  hidePermissionsRadioGroup?: boolean;
}
export const AnalysisCollectionPermissions = ({
  isPrivate,
  setIsPrivate,
  enableShare,
  groupOpts,
  groupId,
  setGroupId,
  hidePermissionsRadioGroup = false
}: AnalysisCollectionPermsItemProps) => <>
    {!hidePermissionsRadioGroup && <GridItem className="pt-8">
        <div>Permissions</div>
        <div className="col-span-2 flex items-center justify-start gap-2">
          <Radio.Group value={isPrivate} onChange={() => setIsPrivate(!isPrivate)} optionType="button" buttonStyle="solid">
            <Radio.Button value={false} disabled={!enableShare}>
              <div className="flex items-center gap-1">
                <TeamOutlined />
                <span>Shared</span>
              </div>
            </Radio.Button>
            <Radio.Button value={true}>
              <div className="flex items-center gap-1">
                <LockOutlined />
                <span>Private</span>
              </div>
            </Radio.Button>
          </Radio.Group>
        </div>
      </GridItem>}

    <GridItem className={`${isPrivate ? "opacity-40" : ""}`} data-sentry-element="GridItem" data-sentry-source-file="AnalysisCollectionFormItems.tsx">
      <div>Share with</div>
      <Select className={`col-span-2 col-start-2`} placeholder="Select group..." options={groupOpts} onChange={e => setGroupId(e)} disabled={isPrivate} value={groupId} data-sentry-element="Select" data-sentry-source-file="AnalysisCollectionFormItems.tsx" />
    </GridItem>
    <GridItem data-sentry-element="GridItem" data-sentry-source-file="AnalysisCollectionFormItems.tsx">
      <div className="col-span-2 col-start-2 text-xs text-gray-500">
        {isPrivate ? "This analysis will be only visible to you." : "This analysis will be visible to everyone in the group."}
      </div>
    </GridItem>
  </>;